import { buildClient } from '../utils/url';
var authService = {
    baseUrl: {
        SERVICE: 'auth',
        AUTH: 'auth',
        API_KEY: 'api-keys',
    },
    auth: {
        VALIDATE_REQUEST: '/validate',
        GET_LOGIN_METHOD: '/method',
        GENERATE_MAGIC_LINK: '/generate-magic-link',
        LOGIN_BASIC: '/basic',
        LOGIN_TOKEN: '/token',
        LOGIN_JWT_TOKEN: '/jwt-token',
        LOGIN_SSO: '/sso',
        ACTIVATE_LOGIN: '/activate',
        SIGN_JWT: '/jwt/sign',
        VALIDATE_JWT: '/jwt/validate',
        LOGOUT: '/logout',
        REQUEST_PASSWORD: '/password/request',
        PASSWORD_RESET: '/password/reset',
        START_REGISTRATION: '/register/start',
        REGISTER_PROFILE: '/register/profile',
    },
    apiKeys: {
        GET_MANY: '/',
        CREATE: '/',
        DELETE_ONE: '/:id',
    },
};
var authServiceClient = {
    auth: buildClient(authService.baseUrl.AUTH, authService.auth),
    apiKeys: buildClient(authService.baseUrl.API_KEY, authService.apiKeys),
};
var authApiGatewayClient = {
    auth: buildClient("".concat(authService.baseUrl.AUTH), authService.auth),
    apiKeys: buildClient("".concat(authService.baseUrl.SERVICE, "/").concat(authService.baseUrl.API_KEY), authService.apiKeys),
};
export { authService, authServiceClient, authApiGatewayClient };
//# sourceMappingURL=auth-service.js.map